export default __webpack_public_path__ + "static/media/planetas.e4fd9a94.svg";